export const studentCard = {
  title: '比赛总结',
  subtitle: '你的比赛详情',
  victory: '胜利！',
  goodTry: '继续努力',
  matchDetails: '比赛详情',
  opponent: '对手',
  location: '地点',
  date: '日期',
  setScores: '盘分',
  set: '第',
  finalScore: '最终比分',
  shareMatch: '分享比赛',
  logAnotherMatch: '记录另一场比赛',
  matchResultCopied: '比赛详情已复制到剪贴板！',
};
